import barba from '@barba/core'
import { gsap } from 'gsap/all'
import barbaPrefetch from '@barba/prefetch'
import { app, bindAppToWindow } from './appState'
import Root from './root'
import DeviceCheck from './utils/deviceCheck'

// barba.Logger.setLevel(0);
barba.use(barbaPrefetch)

document.addEventListener('DOMContentLoaded', () => {
  bindAppToWindow()

  app.html = document.querySelector('html')
  app.body = document.querySelector('body')
  app.DeviceCheck = new DeviceCheck()
  app.Root = new Root()

  // ===============================================================
  // Barba
  // ===============================================================
  // titleタグ以外のmetaタグの情報の書き換えを行う
  const replaceHeadTags = (target) => {
    const head = document.head
    const targetHead = target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0]
    const newPageHead = document.createElement('head')
    newPageHead.innerHTML = targetHead
    const removeHeadTags = ["meta[name='keywords']", "meta[name='description']", "meta[property^='fb']", "meta[property^='og']", "meta[name^='twitter']", "meta[name='robots']", 'meta[itemprop]', 'link[itemprop]', "link[rel='prev']", "link[rel='next']", "link[rel='canonical']"].join(',')
    const headTags = [...head.querySelectorAll(removeHeadTags)]
    headTags.forEach((item) => {
      head.removeChild(item)
    })
    const newHeadTags = [...newPageHead.querySelectorAll(removeHeadTags)]
    newHeadTags.forEach((item) => {
      head.appendChild(item)
    })
  }

  // ページ遷移した際にスクロール位置を決める
  const scroll = () => {
    // ヘッダー追従かどうか
    const headerFixed = false
    // URLに「#」が存在するか
    if (location.hash && !location.hash.includes('#_ga')) {
      // 1) getElementById の引数を "growth-interview" のようにする
      const anchorId = location.hash.slice(1) // 先頭の "#" を除去
      const anchor = document.getElementById(anchorId)
      // あるいは const anchor = document.querySelector(location.hash)

      if (anchor) {
        const rect = anchor.getBoundingClientRect()
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop

        let top = rect.top + scrollTop

        // ヘッダー固定分の調整
        const headerFixed = false
        if (headerFixed) {
          const header = document.getElementById('header')
          if (header) {
            top = top - header.clientHeight
          }
        }
        window.scrollTo(0, top)
      } else {
        // アンカー先が存在しなければトップへ
        window.scrollTo(0, 0)
      }
    } else {
      // ハッシュ自体がなければトップへ
      window.scrollTo(0, 0)
    }
  }

  // Contact Form 7を正常動作させるための関数
  const contactForm7Run = (next) => {
    var cfSelector = 'div.wpcf7 > form'
    var cfForms = $(next.container).find(cfSelector)
    if (cfForms.length) {
      $(cfSelector).each(function () {
        var $form = $(this)
        wpcf7.init($form[0])
      })
    }
  }

  // ブラウザ依存のスクロール位置の復元を manualにする
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual'
  }

  var scrollY = [0]

  // barba enter のhook
  barba.hooks.enter((data) => {
    // 前のページに戻る ではない場合（次のページに進む場合）
    if (data.trigger !== 'back') {
      scroll()
      // 現在のページのスクロール位置を配列にpush
      scrollY.push(barba.history.current.scroll.y)
    }
  })

  // barba after のhook
  barba.hooks.after((data) => {
    // 前のページに戻る ではない場合（次のページに進む場合）
    if (data.trigger !== 'back') {
      scroll()
    } else {
      // スクロール位置の配列の最後値の位置へ移動
      window.scrollTo(0, scrollY.pop())
    }

    // Googleアナリティクスに情報を送る
    if (typeof gtag === 'function') {
      gtag('event', 'page_view', {
        page_title: document.title,
        page_location: location.href,
        page_path: location.pathname,
      })
    }
  })

  // 遅延用　引数分だけ処理を遅らせる
  const delay = (duration) => {
    duration = duration || 2000
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve()
      }, duration)
    })
  }

  //ページを離れる際のアニメーション
  const leaveAnimation = (data) => {
    return gsap.to(data.current.container, {
      duration: 0.4,
      opacity: 0,
      ease: 'power2.out',
    })
  }

  //ページが表示される際のアニメーション
  const enterAnimation = (data) => {
    //let margin = "100px";
    return gsap.from(data.next.container, {
      // marginTop: margin,
      duration: 0.4,
      opacity: 0,
      delay: 0.1,
      ease: 'power2.out',
    })
  }

  // barba設定
  barba.init({
    timeout: 50000,
    // sync: true, //leaveとenterを同時に発火
    // prevent: ({ el }) => el.getAttribute('href').slice(0,1) === '#',
    // cacheIgnore: true, //キャッシュを残さない
    prefetchIgnore: '/wp-admin/', //プリフェッチさせない wordpressバグる
    prevent: ({ el }) => (el.classList && el.classList.contains('js-prevent')) || el.classList.contains('ab-item'),
    transitions: [
      {
        name: 'default-transition',
        once() {
          scroll()
          app.Root.opening()

          //最初にGA4にPV送信
          if (typeof gtag === 'function') {
            gtag('event', 'page_view', {
              page_title: document.title,
              page_location: location.href,
              page_path: location.pathname,
            })
          }
        },
        leave(data) {
          app.Root.leave()
          return leaveAnimation(data)
        },
        beforeEnter({ next }) {
          replaceHeadTags(next)
          // contactForm7Run(next)
        },
        enter(data) {
          app.Root.pageLoad()
          enterAnimation(data)
        },
      },
    ],
    views: [
      {
        namespace: 'home',
        beforeEnter(data) {},
        afterLeave(data) {},
      },
    ],
  })
})
